module.exports = __webpack_public_path__ + "static/media/paper-self-funded.16e81137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paper-self-funded.png
// module id = 291
// module chunks = 0